import Vue from "vue";
import { isEmpty } from "lodash";
import AuthService from "../domain/web/AuthService";

const consumirSsoCookie = async store => {
  const match = document.cookie.match(/(?:^|;\s*)sso_token=([^;]+)/);
  if (!match || !match[1]) {
    return false;
  }

  const token = decodeURIComponent(match[1]);
  const domain = window.location.hostname.replace(/^[^.]+/, "");
  document.cookie =
    "sso_token=; Max-Age=0; path=/; domain=" + domain + "; SameSite=Lax";
  document.cookie = "sso_token=; Max-Age=0; path=/";

  try {
    const authService = new AuthService(Vue.http);
    await authService.setTokenUsuario({ token });
    const usuario = await authService.checkValidateToken();

    if (usuario && usuario.login) {
      await store.dispatch("setUsuario", usuario);
      await store.dispatch("setAcessoVerificado", true);
      return true;
    }
  } catch (err) {
    console.error("Falha ao consumir SSO token:", err);
  }

  return false;
};

const auth = async ({ next, router, to, store }) => {
  await consumirSsoCookie(store);

  const {
    acessoVerificado,
    usuario,
    lembrar,
    rematricula
  } = store.state;

  const path = to.path;

  if (!acessoVerificado && to.path !== "/login") {
    return router.push(`/login?redirect_url=${path}`);
  }

  const authService = new AuthService(Vue.http);
  let validToken = false;

  try {
    validToken = await authService.checkValidateToken();
  } catch (err) {
    console.error("Falha ao validar token:", err);
    validToken = false;
  }

  if (!validToken) {
    return router.push("/login");
  }

  if (acessoVerificado) {
    if (
      !isEmpty(rematricula.responsavelFinanceiro) &&
      rematricula.responsavelFinanceiro.cpf &&
      rematricula.responsavelFinanceiro.nascimento
    ) {
      return next();
    }

    const isUsuarioIgualToken =
      usuario !== undefined &&
      validToken !== undefined &&
      usuario.login === validToken.login;

    if (lembrar && !isUsuarioIgualToken) {
      return router.push("/login");
    }

    if (lembrar && isUsuarioIgualToken && to.path === "/login") {
      return router.push(`/login/${btoa(usuario.login)}`);
    }
  }

  return next();
};

export default auth;



// WEBPACK FOOTER //
// ./src/middleware/auth.js